import { Button } from '@framework/ui/atoms/Button';
import { Modal } from '@framework/ui/elements';
import { Trans, useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  onClose(): void;
};

export const ApplyLicenseThanksModal: React.FC<Props> = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="mx-8" style={{ height: '320px' }}>
        <div className={'p-3 text-xl'}>{t('group.applyLicense.modal.title')}</div>
        <div className="pt-8">
          <Trans i18nKey="group.applyLicense.thanks.message" components={{ lineBreak: <br /> }} />
        </div>
        <div className={'flex justify-center pt-20'}>
          <div className={'pr-2'}>
            <Button color="secondary" onClick={onClose}>
              {t('common.action.close')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
